import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_419: DocMigration = {
  maxSchemaVersion: "0.0.419",
  description: "Refactor Pier categories to enable proper styling and rename the Footing category",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      if (viewTemplate.viewType !== "PLAN_VIEW") {
        continue;
      }
      viewTemplate.categories = replaceSheetGeometryCategories(viewTemplate.categories);
    }

    for (const effectId in json.effects) {
      const effect = json.effects[effectId];
      // effects only apply to the plan view type at the moment
      effect.categories = replaceSheetGeometryCategories(effect.categories);
    }
    return json;
  },
};

function replaceSheetGeometryCategories(categories: string[]) {
  const newCategories: string[] = [];

  const hasCategoryBeenReplaced: { [cat: string]: true } = {};

  for (const category of categories) {
    // ensure that any duplicate categories are ignored
    if (hasCategoryBeenReplaced[category]) {
      continue;
    }

    if (category === "PIER_EDGES_ONLY" || category === "PIER_ALL") {
      hasCategoryBeenReplaced["PIER_EDGES_ONLY"] = true;
      hasCategoryBeenReplaced["PIER_ALL"] = true;
      newCategories.push("PIER", "PIER_HIDDEN");
    } else if (category === "FOOTING_EDGES") {
      hasCategoryBeenReplaced["FOOTING_EDGES"] = true;
      newCategories.push("FOOTING");
    } else {
      hasCategoryBeenReplaced[category] = true;

      newCategories.push(category);
    }
  }

  return newCategories;
}

export default migration_0_0_419;
